// Module
var code = "<input type=\"text\" class=\"fpd-dropdown-current\"/> <div class=\"fpd-dropdown-arrow\"><span class=\"fpd-icon-arrow-dropdown\"></span></div> <div class=\"fpd-dropdown-list\"> <div class=\"fpd-scroll-area\"></div> </div> ";
// Exports
module.exports = code;